import { render, staticRenderFns } from "./CheckoutPackageSelect.vue?vue&type=template&id=63e59aa8"
import script from "./CheckoutPackageSelect.vue?vue&type=script&lang=ts"
export * from "./CheckoutPackageSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports